import React, { useMemo, useState, useEffect, useCallback } from "react";
import { Popup, TextBox, Button, SelectBox, RadioGroup } from 'devextreme-react';
import '../../css/omstyle.css'
import SearchResultsForDialog from './SearchResultsForDialog';

import Toolbar, { Item } from "devextreme-react/toolbar";

import { connect } from "react-redux";
//import Item from "../../so/components/Calculators/BareRootPickListItem";
import AccordionReact from 'devextreme-react/accordion';
import routes from "../../../assets/apiRoutes.json";
import axios from "axios";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const priorityEntities = [
    { id: 1, text: 'Add Same Item With Different Lot' },
    { id: 2, text: 'Add Different Item/Lot' },
    { id: 3, text: 'Do Nothing/ Other' },
]
const AllocateDialog = (props) => {
    var accessToken = props.oidc.user.access_token;
    const [lookupDataList, setLookupDataList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [transactionHeaderId, setTransactionHeaderId] = useState(null);
    const [transactionHeaderData, setTransactionHeaderData] = useState([]);
    const [selectionPriority, setSelectionPriority] = useState(props.data?.detailRowId?priorityEntities[0]:priorityEntities[2]);
    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );
    const selectBoxData = useMemo(() => {
        return new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.GetTransactionsHeader}`,
                key: 'rowid',
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 10
        });
    }, [accessToken]);
    const changeSelectionPriority = useCallback(
        (e) => {
            setSelectionPriority(e.value);
        },
        [setSelectionPriority],
    );
    return (
        <div>
            <Popup
                visible={props.openAllocateDialog}
                onHiding={() => props.setOpenAllocateDialog(false)}
                showCloseButton={true}
                title={props.data?.detailRowId ? "Handle Quantity Diffrence" : "Insert Detail Lines"}
            >
                <div className="row">
                    <div className="col-md-12 main-page">
                        <div id="accordion" >
                            <AccordionReact
                                dataSource={searchpanel}
                                collapsible={true}
                                multiple={false}
                                animationDuration={300}
                                selectedItems={selectedItems}
                                onSelectionChanged={e => {
                                    if (e.currentTarget === e.target) {
                                        selectionChanged(e, e.target);
                                    }
                                }}
                                itemTitleRender={() => (
                                    <Toolbar className="accordian-toolbar">

                                    </Toolbar>

                                )}
                                itemRender={(itemProps) => (
                                    <div>
                                        <form>
                                            <div className="row">
                                                <div className="col-md-3">

                                                    <SelectBox
                                                        stylingMode='outlined'
                                                        labelMode="static"
                                                        label="Transaction #"
                                                        defaultValue={props.data?.headerRowId}
                                                        dataSource={selectBoxData}
                                                        valueExpr='rowid'
                                                        displayExpr='code'
                                                        acceptCustomValue={true}
                                                        searchEnabled={true}
                                                        searchExpr="Code"
                                                        searchMode="contains"
                                                        onValueChanged={(e) => {
                                                            setTransactionHeaderId(e.value);
                                                        }}
                                                        disabled={props.data?.detailRowId ? true : false}
                                                    />
                                                </div>
                                                <div className="col-md-9">
                                                    <RadioGroup
                                                        items={priorityEntities}
                                                        value={selectionPriority}
                                                        onValueChanged={changeSelectionPriority}
                                                        layout="horizontal"
                                                    />

                                                </div>

                                            </div>
                                        </form>

                                    </div>
                                )}
                                id="accordion-container" className="accordion-height"
                            />
                        </div>
                    </div>
                </div>
                <SearchResultsForDialog searchPanelStatus={searchPanelStatus} data={props.data} accessToken={accessToken} headerRowId={transactionHeaderId} priorityEntities={selectionPriority} />
            </Popup>
        </div>
    )
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AllocateDialog);